import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useMortgageeForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Mortgagee',
        isTitleHidden: true,
        type: 'array',
        name: 'mortgagees',
        isDraggable: true,
        dragFieldName: 'position',
        isAddDisabled: (vals) => vals.length === 2,
        fields: [
          {
            title: (vals, index, arrayIndex) => {
              return arrayIndex === 0 ? '1st Mortgagee' : '2nd Mortgagee';
            },
            name: 'mortgagee_type',
            type: 'select',
            required: true,
            customValidation: [
              'unique-type',
              'Must be unique',
              function (value) {
                const { options } = this;
                const { mortgagees } = options.context;

                const occurrences = mortgagees.filter(
                  (mortgagee) => mortgagee.mortgagee_type === value
                ).length;

                // The value is unique if it appears only once
                return occurrences === 1;
              },
            ],
            options: [
              {
                label: 'Servicer',
                value: 'Servicer',
              },
              {
                label: 'Lender',
                value: 'Lender',
              },
              {
                label: 'Lien Holder',
                value: 'Lienholder',
              },
            ],
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useMortgageeForm;
